import styled from "styled-components";
import { useTranslation } from "react-i18next";
// start of styled-components
const Container = styled.div`
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 10px #0000001a;
  border-radius: 10px;
  padding: 1.875rem 1.9063rem;
  background: #ffffff;
`;
const MetricsHeadingContainer = styled.div`
  display: flex;
  align-items: center;
`;
const MetricHeading = styled.div`
  font-size: 1.125rem;
  line-height: 1.5625rem;
  color: ${(props) => props.theme.colors.gray[800]};
`;
interface MetricsPercentageChangePropType {
  $positive: boolean;
}
const MetricPercentageChange = styled.div<MetricsPercentageChangePropType>`
  width: 3.25rem;
  height: 1.3125rem;
  background: ${(props) =>
    props.$positive
      ? props.theme.colors.green[600]
      : props.theme.colors.red[500]}26;
  font-size: 0.625rem;
  color: ${(props) =>
    props.$positive
      ? props.theme.colors.green[600]
      : props.theme.colors.red[500]};
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  margin-left: 0.75rem;
`;
const MetricsData = styled.div`
  font-size: 1.75rem;
  line-height: 2.4375rem;
  font-weight: 700;
  margin-top: 0.5rem;
  color: ${(props) => props.theme.colors.gray[800]};
`;
const MetricPastPeriodData = styled.div`
  line-height: 1.25rem;
  font-size: 0.875rem;
  color: ${(props) => props.theme.colors.gray[600]};
`;
// end of styled components
function MetricsDataComponent({
  heading,
  percentIncrease,
  value,
  pastPeriodValue,
}: {
  heading: string;
  percentIncrease: number;
  value: number;
  pastPeriodValue: number;
}) {
  const { t } = useTranslation();
  return (
    <Container>
      <MetricsHeadingContainer>
        <MetricHeading>{t(heading)}</MetricHeading>
        <MetricPercentageChange $positive={percentIncrease >= 0.0}>
          {`${percentIncrease >= 0 ? "+" : ""}${percentIncrease}%`}
        </MetricPercentageChange>
      </MetricsHeadingContainer>
      <MetricsData>{value}</MetricsData>
      <MetricPastPeriodData>
        {pastPeriodValue} {t("adminDashboard.pastPeriod")}
      </MetricPastPeriodData>
    </Container>
  );
}

export default MetricsDataComponent;
